import React from 'react';
import { SparkProjectResource } from '../types/sparkTypes';
import styles from '../styles/PDFFileCard.module.css';
import parentStyles from '../styles/ProjectInsightsWallPanel.module.css'; // For button styles

// Icons
import { DeleteIcon } from './icons/DeleteIcon'; // Import DeleteIcon

interface PDFFileCardProps {
    resource: SparkProjectResource;
    onOpenRemoveConfirm: (resourceFqn: string | null, jobFqn: string | null, resourceTitle: string) => void;
    onOpenPdfLightbox: (fileId: string, title?: string) => void;
}

const PDFFileCard: React.FC<PDFFileCardProps> = (
    { resource, onOpenRemoveConfirm, onOpenPdfLightbox }
) => {
    const displayName = resource.title || resource.fqn || 'Uploaded PDF';
    const canRemove = !!resource.fqn || !!resource.job_fqn;
    const canView = !!resource.pdf_file_id;
    const isProcessing = !resource.is_ready;

    const handleCardClick = () => {
        // PDF cards open the viewer
        console.log('[PDFFileCard] handleCardClick called', { isProcessing, canView, pdf_file_id: resource.pdf_file_id });
        // Allow opening viewer if pdf_file_id exists, regardless of isProcessing
        if (!canView || !resource.pdf_file_id) return;
        console.log('[PDFFileCard] Calling onOpenPdfLightbox with ID:', resource.pdf_file_id);
        onOpenPdfLightbox(resource.pdf_file_id, displayName);
    };

    const handleRemoveClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation(); // Prevent card click
        if (canRemove) {
            onOpenRemoveConfirm(resource.fqn ?? null, resource.job_fqn ?? null, displayName);
        }
    };
    return (
        <li 
            className={`${styles.cardContainer} ${isProcessing ? styles.processingAnimation : ''}`}
            onClick={handleCardClick}
            title={isProcessing ? 'Processing...' : `View ${displayName}`}
        >
            <div className={styles.contentContainer}>
                <h3 className={styles.title}>{displayName}</h3>
                {/* Show processing status directly below title */}
                {isProcessing && (
                    <span className={styles.processingStatusText}>Processing...</span>
                )}
                {/* <div className={parentStyles.sourceBadge}>
                    <span className={parentStyles.sourceBadgeIcon}><PDFIcon /></span>
                    <span className={parentStyles.sourceBadgeText}>Uploaded PDF</span>
                </div> */}
            </div>
            
            {/* Action buttons (visible on hover via CSS) */}
            <div className={styles.actionsContainer}>
                <button
                    className={`${parentStyles.textButton} ${parentStyles.removeButton}`}
                    onClick={handleRemoveClick}
                    title={`Remove ${displayName}`}
                    disabled={!canRemove}
                >
                    <DeleteIcon style={{ fontSize: '16px' }} />
                </button>
            </div>
        </li>
    );
};

export default PDFFileCard; 
